module.exports = __webpack_public_path__ + "img/YellowWood-01.8fe64256.png";